<mat-dialog-content class="modal">
  <h3>Bitte kontaktieren Sie uns zu Ihrer Offshore-Windanlage</h3>
  <p>
    Vielen Dank für Ihr Interesse. Bezüglich Ihrer Offshore-Windanlage würden wir gerne in den
    direkten Austausch mit Ihnen treten. Bitte senden Sie uns eine E-Mail an
    <a href="mailto:{{ contactEmail }}" class="blue-url">
      {{ contactEmail }}
    </a>
    und fügen Sie erste Informationen zu Ihrer Anlage bei.
  </p>

  <p>Wir freuen uns auf Ihre Nachricht.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="modal-button" (click)="closeDialog()">Schließen</button>
</mat-dialog-actions>
